import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter/components/AdvancedFilterRow';
import { TagsInput } from 'shared/components/TagsInput';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectExcludeWordsFilter } from 'shared/selectors/advancedFilters';

export const ExcludeWordsContainer: FC = () => {
  const { label, value: values, placeholder } = useSelector(selectExcludeWordsFilter);

  const onChange = useFilterChangeCallback();

  const handleAdd = useCallback(
    (addedValue: string) => {
      onChange({ action: 'setExcludeWords', arguments: [values ? [...values, addedValue] : [addedValue]] });
    },
    [onChange, values],
  );

  const handleRemove = useCallback(
    (removedValue: string) => {
      const nextValue = values ? values.filter(value => value !== removedValue) : null;

      onChange({ action: 'setExcludeWords', arguments: [nextValue?.length ? nextValue : null] });
    },
    [onChange, values],
  );

  return (
    <AdvancedFilterRow label={label}>
      <TagsInput
        id="advancedFilter_excludeWords_tagsInput"
        placeholder={placeholder}
        value={values}
        onAdd={handleAdd}
        onRemove={handleRemove}
      />
    </AdvancedFilterRow>
  );
};
